import React from 'react';
import { DateFormat } from '@ui-library/pickers/DateFormat';
import { useCloudSourceInfo } from './cloudSourcesInfo';

const CloudSourceStats: React.FC = () => {
  const { isPaused, isSyncing, lastRunData, nextSyncAt, noConnections } = useCloudSourceInfo();

  const lastStatus = lastRunData?.find((data) => !data.taskId && !data.taskRunId);

  const noRun = lastRunData?.length === 0;
  return (
    <div style={{ fontSize: 16, lineHeight: '32px' }}>
      {noRun && (
        <>
          <div>Your pipeline is ready.</div>
          {(!noConnections && !isPaused && (
            <div>
              The first sync will start at <DateFormat date={nextSyncAt} />
            </div>
          )) ||
            (isPaused && !noConnections && (
              <div>Enable your source to schedule the next sync.</div>
            ))}
        </>
      )}
      {(isPaused || !isSyncing) && lastStatus && lastStatus.finishedAt && (
        <div>
          Last Sync at <DateFormat date={lastStatus.finishedAt} />
        </div>
      )}
      {isSyncing && lastStatus && (
        <div>
          Started at <DateFormat date={lastStatus.startedAt} />
        </div>
      )}
      {noConnections && <div>Connect at least one destination to schedule the next sync.</div>}
    </div>
  );
};

export default CloudSourceStats;
